
export interface InclusionInterface {
  _id: string;
  builderId: string;
  type: string;
  inclusions: InclusionPackageInterface[];
}

export interface InclusionPackageInterface {
  name: string;
  description: string[];
  url: string;
}

export type CreateInclusionInterface = Omit<InclusionInterface, "_id">;

export type QueryInclusionInterface = Partial<InclusionInterface>;

export type UpdateInclusionInterface = Partial<InclusionInterface>;

export const inclusionDefault: QueryInclusionInterface = {
  _id: "",
  builderId: "",
  type: "",
  inclusions: [
    {
      name: "",
      description: [],
      url: "",
    },
  ],
};
